module.exports = __webpack_public_path__ + "static/6325-7557fc19beedec2b38be00c48db76c8e.png";